module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classNames,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-header"
    },
    on: {
      "click": function($event) {
        _vm.topAnim()
      }
    }
  }, [_c('main-logo')], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "bottom-footer"
    }
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "title": "Contact Neil"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    },
    on: {
      "click": _vm.toggleContactPane
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.reload
    }
  }, [_c('i', {
    staticClass: "icon-chevron-up"
  })])]), _vm._v(" "), _c('aside', {
    attrs: {
      "id": "vector-pane"
    }
  }, [_c('top-icons')], 1), _vm._v(" "), _c('aside', {
    staticClass: "fixed-pane",
    attrs: {
      "id": "contact-pane"
    }
  }, [_c('contact', {
    attrs: {
      "active": _vm.showContactPane
    }
  })], 1), _vm._v(" "), _c('cookie-compliance')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6a4746"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 92
// module chunks = 1